// published_until пока нет в @mivis/petmart-api — держим локально, чтобы не публиковать пакет ради одного поля
interface IHorsePublication {
  published_until?: string
}

export interface IPopulatedHorse extends Components.Schemas.IPopulatedHorseWViewCount, IHorsePublication { }
export interface IPopulatedHorseWithoutCount extends Components.Schemas.IPopulatedHorse, IHorsePublication { }
export interface IAdminHorsesQueryResponse extends Components.Schemas.IAdminHorsesQueryResponse {
  horses: IPopulatedHorseWithoutCount[]
}
export interface IActionsHorseRequest extends Components.Schemas.IActionsHorseRequest { }
export interface IAdminChangeHorseStatusRequest extends Components.Schemas.IAdminChangeHorseStatusRequest { }

export type TStatusOrder = 'asc' | 'desc' | undefined

export interface IHorseQueryRequest extends Components.Schemas.IHorseQueryRequest {
  statuses?: EHorseStatus[]
  statusOrder?: TStatusOrder
}

export interface IBreed extends Components.Schemas.IBreed { }
export interface ISuit extends Components.Schemas.ISuit { }
export interface IHorseCategory extends Components.Schemas.IHorseCategory { }
export interface IHorseFormInformation extends Components.Schemas.IHorseFormInformation { }
export interface ICompetitionHistory extends Components.Schemas.ICompetitionHistory { }
export interface IHorseDocument extends Components.Schemas.IDocument { }
export interface ICommunication extends Components.Schemas.ICommunication { }
export interface IPreferredCommunication extends Components.Schemas.IPreferredCommunication { }
export interface IHorseLocation extends Components.Schemas.ILocation { }

export enum EHorseStatus {
  MODERATION = 'MODERATION',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
}

// Причину проставляет бэкенд, когда истекают 30 дней публикации
export const HORSE_EXPIRED_REASON = 'Истёк срок публикации'
export const HORSE_ADMIN_UNPUBLISHED_REASON = 'Снята с публикации администратором площадки'
// Ответы владельца на «Где вы продали лошадь?» — с любым из них лошадь снята с публикации как проданная
export const HORSE_SOLD_REASONS = ['На HorseSmart', 'На другой площадке', 'Лично']
export const isHorseSoldReason = (reason?: string) => !!reason && HORSE_SOLD_REASONS.includes(reason)

export enum ESex {
  STALLION = 'stallion',
  MARE = 'mare',
  GELDING = 'gelding',
}

export const localeSex: Record<ESex, string> = {
  [ESex.STALLION]: 'Жеребец',
  [ESex.MARE]: 'Кобыла',
  [ESex.GELDING]: 'Мерин'
}

export interface IUpdateHorseRequest {
  name?: string
  sex?: ESex
  breed?: string
  suit?: string
  category?: string
  birthDate?: string
  withersHeight?: number
  price?: number
  location?: Pick<IHorseLocation, 'name' | 'lat' | 'lng'>
  desc?: string
  reg_number?: string
  genealogy?: string
  birthplace?: string
  competition_history?: ICompetitionHistory[]
  communication?: ICommunication
  images?: File[]
  toRemoveImages?: string[]
  video_cover?: File
  toRemoveVideoCover?: string
  documents?: File[]
  documentsNames?: string[]
  toRemoveDocuments?: string[]
}
